import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  Pressable,
  ImageBackground,
  Image,
  TextInput,
  Platform,
} from "react-native";
import { ids, styles } from "./Style";
import { isGradientAllowed, ScreenNameList } from "@lib/utilities/Constants";

import {
  BRANDING_BACKGROUND_IMAGE,
  INFO_ICON,
  LOGO,
} from "../../resources/IMAGES";
import CommonStyle from "../../assets/styles/common-style";
import RegisterSuccessView from "../../components/register/RegisterSuccessView";
import { useResetPassword } from "@lib/hooks/passwords/useResetPassword";
import { Header } from "../../components/header/Header";
import { RESET_PASSWORD_ROUTE } from "../../navigation/NavigationConstants";

import KeyboardScrollWrapper from "../../components/common/KeyboardAvoidingViewWrapper";
import { theme } from "../../theme/theme";
import Crashlytics from "@lib/utilities/crashlyticsUtils/CrashlyticsUtils";
import { description, labelText, messages } from "../../resources/strings";
import MainContainer from "../../components/common/MainContainer";
import GradientBackground from "../../components/gradient-background/GradientBackground";

const ResetPassword = ({ navigation }: any) => {
  const { states, refs, actions } = useResetPassword(navigation);

  useEffect(() => {
    Crashlytics.logScreen(RESET_PASSWORD_ROUTE);
    actions.checkSession();
  }, []);

  const AlertViews = () => (
    <>
      {states.isPasswordResetSuccess && (
        <View style={[styles.successContainer]}>
          <View style={styles.success} dataSet={{ media: ids.success }}>
            <RegisterSuccessView
              onNoInternet={async () => {
                actions.showInternetalert();
              }}
              screenName={ScreenNameList.resetPassword}
              navigation={navigation}
            />
          </View>
        </View>
      )}
    </>
  );

  const Content = () => (
    <>
      <View style={{ zIndex: theme.zIndex.max }}>
        <Header
          screenName={ScreenNameList.resetPassword}
          navigation={navigation}
        />
      </View>
      <>
        <KeyboardScrollWrapper>
          <View style={[styles.mainContainer, styles.formContainer]}>
            {!states.isPasswordResetSuccess && (
              <View
                style={[styles.registerContainer]}
                dataSet={{ media: ids.registerContainer }}
              >
                <View
                  style={[styles.logoBlock]}
                  dataSet={{ media: ids.logoBlock }}
                  testID="reset-page-brand-logo-container"
                >
                  <Image
                    style={styles.Logo}
                    dataSet={{ media: ids.Logo }}
                    source={LOGO}
                    resizeMode={"contain"}
                    testID="reset-page-brand-logo"
                  />
                </View>
                <View
                  style={[styles.formBlock]}
                  dataSet={{ media: ids.formBlock }}
                >
                  <View
                    style={[styles.heading]}
                    dataSet={{ media: ids.heading }}
                    testID="reset-page-header-container"
                  >
                    <Text
                      style={[styles.headingText]}
                      dataSet={{ media: ids.headingText }}
                      testID="reset-page-header-label"
                    >
                      Reset Password
                    </Text>
                  </View>
                  <>
                    <View
                      style={[styles.formGroup]}
                      dataSet={{ media: ids.formGroup }}
                      testID="reset-page-current-password-container"
                    >
                      <Text
                        style={[styles.inputLabel]}
                        dataSet={{ media: ids.inputLabel }}
                        testID="reset-page-current-password-label"
                      >
                        {labelText.reset.currentPassword}
                      </Text>
                      <View
                        style={styles.passwordContainer}
                        testID="reset-page-current-password-input-container"
                      >
                        <TextInput
                          editable={!states.isLoading}
                          ref={refs.currentPasswordRef as any}
                          style={
                            states.currentPasswordHelpText == "" ||
                            ((states.currentPasswordHelpText ==
                              messages.validation.invalidPasscodeFormat ||
                              states.currentPasswordHelpText ==
                                messages.validation.passcodeLengthMessage) &&
                              !states.isFinalSubmit)
                              ? styles.input
                              : styles.inputRed
                          }
                          onChangeText={(text) =>
                            actions.validateCurrentPassword(
                              text,
                              states.isFinalSubmit,
                            )
                          }
                          value={states.currentPassword}
                          autoCorrect={false}
                          secureTextEntry={!states.showCurrentPassword}
                          autoCapitalize="none"
                          returnKeyType="next"
                          onSubmitEditing={() => {
                            // @ts-ignore
                            refs.newPasswordRef.current.focus();
                          }}
                          blurOnSubmit={false}
                          testID="reset-page-current-password-input"
                        />
                        <Pressable
                          style={[styles.showPassowrd]}
                          dataSet={{ media: ids.showPassowrd }}
                          onPress={() => {
                            actions.togglePasswordVisiblity(
                              0,
                              !states.showCurrentPassword,
                            );
                          }}
                          testID="reset-page-current-password-show-hide-button"
                        >
                          <Text
                            style={[styles.whiteText]}
                            dataSet={{ media: ids.whiteText }}
                            testID="reset-page-current-password-show-hide-label"
                          >
                            {states.showCurrentPasswordLabel}
                          </Text>
                        </Pressable>
                      </View>
                      <View
                        style={[styles.passwordErrorContainer]}
                        dataSet={{ media: ids.passwordErrorContainer }}
                        testID="reset-page-current-password-error-container"
                      >
                        {!states.isFinalSubmit ? (
                          <Text
                            style={[
                              styles.passwordMessage,
                              styles.passwordMessageError,
                            ]}
                            dataSet={{ media: ids.passwordMessage }}
                          >
                            {states.currentPasswordHelpText}
                          </Text>
                        ) : (
                          <Text
                            style={[styles.passwordMessage]}
                            dataSet={{ media: ids.passwordMessage }}
                          >
                            {states.currentPasswordHelpText}
                          </Text>
                        )}
                      </View>
                    </View>
                    <View
                      style={[styles.formGroup]}
                      dataSet={{ media: ids.formGroup }}
                      testID="reset-page-new-password-container"
                    >
                      <Text
                        style={[styles.inputLabel]}
                        dataSet={{ media: ids.inputLabel }}
                        testID="reset-page-new-password-label"
                      >
                        {labelText.reset.newPassword}
                      </Text>
                      <View
                        style={styles.passwordContainer}
                        testID="reset-page-new-password-input-container"
                      >
                        <TextInput
                          editable={!states.isLoading}
                          ref={refs.newPasswordRef as any}
                          style={
                            states.newPasswordHelpText == "" ||
                            ((states.newPasswordHelpText ==
                              messages.validation.invalidPasscodeFormat ||
                              states.currentPasswordHelpText ==
                                messages.validation.passcodeLengthMessage) &&
                              !states.isFinalSubmit)
                              ? styles.input
                              : styles.inputRed
                          }
                          onChangeText={(text) =>
                            actions.validateNewPassword(
                              text,
                              states.isFinalSubmit,
                            )
                          }
                          value={states.newPassword}
                          autoCorrect={false}
                          secureTextEntry={!states.showNewPassword}
                          autoCapitalize="none"
                          returnKeyType="next"
                          onSubmitEditing={() => {
                            // @ts-ignore
                            refs.confirmNewPasswordRef?.current.focus();
                          }}
                          blurOnSubmit={false}
                          testID="reset-page-new-password-input"
                        />
                        <Pressable
                          style={[styles.showPassowrd]}
                          dataSet={{ media: ids.showPassowrd }}
                          onPress={() => {
                            actions.togglePasswordVisiblity(
                              1,
                              !states.showNewPassword,
                            );
                          }}
                          testID="reset-page-new-password-show-hide-button"
                        >
                          <Text
                            style={[styles.whiteText]}
                            dataSet={{ media: ids.whiteText }}
                            testID="reset-page-new-password-show-hide-label"
                          >
                            {states.showNewPasswordLabel}
                          </Text>
                        </Pressable>
                      </View>
                      <View
                        style={[styles.passwordErrorContainer]}
                        dataSet={{ media: ids.passwordErrorContainer }}
                        testID="reset-page-new-password-error-container"
                      >
                        {!states.isFinalSubmit ? (
                          <Text
                            style={[
                              styles.passwordMessage,
                              styles.passwordMessageError,
                            ]}
                            dataSet={{ media: ids.passwordMessage }}
                          >
                            {states.newPasswordHelpText}
                          </Text>
                        ) : (
                          <Text
                            style={[styles.passwordMessage]}
                            dataSet={{ media: ids.passwordMessage }}
                          >
                            {states.newPasswordHelpText}
                          </Text>
                        )}
                      </View>
                    </View>
                    <View
                      style={[styles.formGroup]}
                      dataSet={{ media: ids.formGroup }}
                      testID="reset-page-confirm-new-password-container"
                    >
                      <Text
                        style={[styles.inputLabel]}
                        dataSet={{ media: ids.inputLabel }}
                        testID="reset-page-confirm-new-password-label"
                      >
                        {labelText.reset.confirmNewPassword}
                      </Text>
                      <View
                        style={styles.passwordContainer}
                        testID="reset-page-confirm-new-password-input-container"
                      >
                        <TextInput
                          editable={!states.isLoading}
                          ref={refs.confirmNewPasswordRef as any}
                          style={
                            states.confirmNewPasswordHelpText == ""
                              ? styles.input
                              : styles.inputRed
                          }
                          onChangeText={actions.setConfirmNewPassword}
                          value={states.confirmNewPassword}
                          autoCorrect={false}
                          secureTextEntry={!states.showConfirmPassword}
                          autoCapitalize="none"
                          returnKeyType="done"
                          onSubmitEditing={() => {
                            actions.resetPasswordAction();
                          }}
                          blurOnSubmit={false}
                          testID="reset-page-confirm-new-password-input"
                        />
                        <Pressable
                          style={[styles.showPassowrd]}
                          dataSet={{ media: ids.showPassowrd }}
                          onPress={() => {
                            actions.togglePasswordVisiblity(
                              2,
                              !states.showConfirmPassword,
                            );
                          }}
                          testID="reset-page-confirm-new-password-show-hide-button"
                        >
                          <Text
                            style={[styles.whiteText]}
                            dataSet={{ media: ids.whiteText }}
                            testID="reset-page-confirm-new-password-show-hide-label"
                          >
                            {states.showConfirmPasswordLabel}
                          </Text>
                        </Pressable>
                      </View>
                      <View
                        style={[styles.errorContainer]}
                        dataSet={{ media: ids.errorContainer }}
                        testID="reset-page-confirm-new-password-error-container"
                      >
                        <Text
                          style={[styles.errorMessage]}
                          dataSet={{ media: ids.errorMessage }}
                        >
                          {states.confirmNewPasswordHelpText}
                        </Text>
                      </View>
                    </View>
                    <View
                      style={[styles.errorContainer]}
                      dataSet={{ media: ids.errorContainer }}
                      testID="reset-page-password-info-container"
                    >
                      <Image
                        style={styles.infoIcon}
                        dataSet={{ media: ids.infoIcon }}
                        source={INFO_ICON}
                        testID="reset-page-info-icon-image"
                      />
                      <Text
                        style={[styles.infoMessage]}
                        dataSet={{ media: ids.infoMessage }}
                        testID="reset-page-password-info-description-label"
                      >
                        {description.reset.description1}
                      </Text>
                    </View>
                    <Pressable
                      style={[styles.submitBtn]}
                      dataSet={{ media: ids.submitBtn }}
                      onPress={() => {
                        actions.resetPasswordAction();
                      }}
                      testID="reset-page-submit-button"
                    >
                      <Text
                        style={[styles.btnText]}
                        dataSet={{ media: ids.btnText }}
                        testID="reset-page-submit-button-label"
                      >
                        {labelText.button.submit}
                      </Text>
                    </Pressable>

                    <Pressable
                      onPress={() => {
                        actions.forgotPasswordAction();
                      }}
                      testID="reset-page-forgot-password-link-button"
                    >
                      <Text
                        style={[styles.loginLink]}
                        dataSet={{ media: ids.loginLink }}
                        testID="reset-page-forgot-password-link-label"
                      >
                        {labelText.commonLabels.forgotPassword}
                      </Text>
                    </Pressable>
                  </>
                </View>
              </View>
            )}
          </View>
        </KeyboardScrollWrapper>

        <AlertViews />
      </>
    </>
  );

  if (isGradientAllowed && Platform.OS !== "web") {
    return (
      <MainContainer
        screenName={ScreenNameList.resetPassword}
        navigation={navigation}
        onEndTimer={() => {
          actions.setErrorHandle(messages.error.noError);
        }}
        errorData={{
          message: states.errorHandle,
          screenName: ScreenNameList.resetPassword,
        }}
      >
        <GradientBackground styles={CommonStyle.styles.coverImage}>
          {Content()}
        </GradientBackground>
      </MainContainer>
    );
  }
  return (
    <MainContainer
      screenName={ScreenNameList.resetPassword}
      navigation={navigation}
      onEndTimer={() => {
        actions.setErrorHandle(messages.error.noError);
      }}
      errorData={{
        message: states.errorHandle,
        screenName: ScreenNameList.resetPassword,
      }}
    >
      <ImageBackground
        source={BRANDING_BACKGROUND_IMAGE}
        style={[
          CommonStyle.styles.coverImage,
          isGradientAllowed && styles.gradientBg,
        ]}
        imageStyle={{
          top: 0,
        }}
      >
        {Content()}
      </ImageBackground>
    </MainContainer>
  );
};

export default ResetPassword;
